import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"
import { type SocialMediaTypesName, socialMediaTypesConf } from "./referential"

export enum DigitalEnum {
  WEBSITE = "website",
  SOCIAL_MEDIA_URLS = "socialMediaUrls",
  SITE_URL = "siteUrl",
  WEBSITE_SERVICE = "websiteService",
}

// Type for social media URLs - explicit type instead of inferred unknown
export type SocialMediaUrls = Record<SocialMediaTypesName, string | null>

const socialMediaReferential = () => {
  const shape = Object.keys(socialMediaTypesConf).reduce<YupTypes.ObjectShape>(
    (res, name) => {
      res[name] = Yup.string().url().nullable().default(null)
      return res
    },
    {},
  )
  return Yup.object().shape(shape).default(null)
}

export const digitalSchema = Yup.object({
  [DigitalEnum.SOCIAL_MEDIA_URLS]: socialMediaReferential(),
  [DigitalEnum.WEBSITE]: Yup.object({
    [DigitalEnum.SITE_URL]: Yup.string()
      .nullable()
      .transform((value) => value || null)
      .url("L'URL doit être valide")
      // Custom validation to check sibling field using this.parent
      // https://github.com/jquense/yup#mixedtestname-string-message-string--function-test-function-schema
      .test(
        "require-service-if-url",
        "L'URL est obligatoire si le service est renseigné",
        function (value) {
          const { websiteService } = this.parent
          if (websiteService && !value) {
            return false
          }
          return true
        },
      )
      .default(null),
    [DigitalEnum.WEBSITE_SERVICE]: Yup.string()
      .nullable()
      .transform((value) => value || null)
      .test(
        "require-url-if-service",
        "Le service est obligatoire si l'URL est renseignée",
        function (value) {
          const { siteUrl } = this.parent
          if (siteUrl && !value) {
            return false
          }
          return true
        },
      )
      .default(null),
  }),
})

// Override inferred type to replace unknown index signature with explicit SocialMediaUrls type
export type DigitalFormValues = Omit<
  YupTypes.InferType<typeof digitalSchema>,
  "socialMediaUrls"
> & {
  socialMediaUrls: SocialMediaUrls | null
}
